/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import React from 'react';

const Span = styled('span')``;
interface MaterialSymbolProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  children: string | React.ReactNode | React.ReactNode[];
  variant?: 'outlined' | 'fill';
  sx?: SxProps<Theme>;
}
export const MaterialSymbol: React.FC<MaterialSymbolProps> = ({
  children,
  variant = 'outlined',
  sx,
  ...props
}) => {
  return (
    <Span sx={sx} className={`material-symbols-${variant}`} aria-hidden='true' {...props}>
      {children}
    </Span>
  );
};

export default MaterialSymbol;
